<template>
  <v-layout row justify-center>
    <v-dialog v-model="visible" persistent max-width="600px">
      <v-card class="mx-auto">
        <v-toolbar dark color="primary" height="45">
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn small icon color="primary" @click="close"><v-icon>close</v-icon></v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <file-upload
                  :url="uploadUrl"
                  :validate="validate"
                  @success="success"
                  @error="onError"
                />
              </v-flex>
              <v-flex xs12>
                <span v-html="message"></span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="close">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import notification from '@/helpers/notification'
import FileUpload from './FileUpload'

export default {
  name: 'ImportDialog',
  props: {
    title: {type: String, default: 'Import'},
    message: {type: String, default: ''},
    visible: {type: Boolean, default: false},
    uploadUrl: {type: String, required: true},
    validate: {type: Boolean, default: false},
  },
  mounted() {},
  data() {
    return {}
  },
  watch: {
    visible() {},
  },
  methods: {
    close() {
      this.$emit('close')
    },
    success(e) {
      //notification('File uploaded successfully', 'info')
      this.$emit('onSuccess', e)
    },
    onError() {
      notification('Error importing the file', 'error')
    },
  },
  components: {
    FileUpload,
  },
}
</script>

<style></style>
